import React from "react";
import { Redirect } from 'react-router-dom';
import RegistrationForm from '../Forms/RegistrationForm.jsx';
import { Constants } from '../Core/Constants';
import PasswordChanged from '../Components/PasswordChanged.jsx';
import { UserProvider } from '../Providers/UserProvider';
import { BaseProvider } from '../Providers/BaseProvider';
import ChangePasswordForm from '../Forms/ChangePasswordForm.jsx';





export default class ChangePasssword extends React.Component {
	state = {
		success: false
	}

	handleChangePassword = (values, setSubmitting) => {
		UserProvider.changePassword(
			{
				oldPassword: values.oldPassword,
				newPassword: values.password
			}, () => {
				window.gtm.loadAccount("changepassword");
				this.setState({ success: true });
			},
			(error) => {
				BaseProvider.applyServerFormValidation(actions, error);
			}
		);
	}

	handleChangeField = (e, prop) => {
		var form = this.state.form;
		form[prop] = e.target.value;
		this.setState({ form: form });
	}


	render() {

		if (this.state.success) {
			return <PasswordChanged />;
		}
		else {
			var T = window.Texts.login;

			return (
				<div className="password-change-page">
					<div className="cover">
						<div className="headline">
							<h1>{T.confirmPasswordTitle}</h1>
						</div>
						<div className="inner-305">
							<ChangePasswordForm onSubmit={(values, setSubmitting) => this.handleChangePassword(values, setSubmitting)} oldPassword={true}/>
						</div>
					</div>
				</div>);
		}
	}
}